import { render, staticRenderFns } from "./plan-management.vue?vue&type=template&id=b494b220&scoped=true"
import script from "./plan-management.vue?vue&type=script&lang=js"
export * from "./plan-management.vue?vue&type=script&lang=js"
import style0 from "./plan-management.vue?vue&type=style&index=0&id=b494b220&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b494b220",
  null
  
)

export default component.exports